import React from "react"

interface IDefaultValue {
    isAuthenticated: boolean,
    setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>,
    isCookied: boolean,
    setIsCookied: React.Dispatch<React.SetStateAction<boolean>>,
    currentUser: any,
    setCurrentUser: React.Dispatch<React.SetStateAction<object>>,
    signUp: Function,
    signIn: Function,
    signOut: Function,
    refreshUser: Function,
    userIs: Function,
    isOwner: Function
}

export const defaultValue = {
    isAuthenticated: false,
    setIsAuthenticated: () => {},
    isCookied: false,
    setIsCookied: () => {},
    currentUser: null,
    setCurrentUser: () => {},
    signUp: () => {},
    signIn: () => {},
    signOut: () => {},
    refreshUser: () => {},
    userIs: () => {},
    isOwner: () => {}
} as IDefaultValue